import {
  Box,
  BoxProps,
  Typography,
  useMediaQuery
} from "@mui/material";
import {
  styled,
  useTheme
} from "@mui/material/styles";
import { Icon } from "../../components";

type StatusBoxProps =
  & Omit<
    BoxProps,
    "children"
  >
  & BoxProps
  & {
    accent: string,
    message?: string,
    inHeroBanner?: boolean,
    inZoomCard?: boolean,
    icon: string,
  }

export const StyledStatusBox = styled(Box)<{
  $accent: string
  $message?: string,
  $inHeroBanner?: boolean
  $inZoomCard?: boolean
} & BoxProps>(({
  $accent,
  $message,
  $inHeroBanner,
  $inZoomCard,
  theme
}) => ({
  alignItems: "center",
  backgroundColor: $accent,
  borderRadius: (($inHeroBanner || $inZoomCard) ? "0 0.25rem 0.25rem 0" : "0.25rem 0.25rem 0.25rem 0"),
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  color: theme.palette.common?.black,
  display: "flex",
  gap: "1rem",
  height: "2.5rem",
  justifyContent: "center",
  left: ($inHeroBanner ? "-0.5rem" : 0),
  padding: theme.spacing(1),
  pointerEvents:"none",
  position: "absolute",
  top: ($inHeroBanner ? "5.375rem" : ($inZoomCard ? "1.5rem" : "-0.7rem")),
  width: $message ? "fit-content" : "2.5rem",

  [theme.breakpoints.down("sm")]:{
    gap: "0.5rem",
    height: "unset",
    minHeight: "unset",
    minWidth: "unset",
    padding: "5px 8px",
    width: $message ? "fit-content" : "unset"
  }
}));

export function StatusBox({
  icon,
  message,
  inHeroBanner,
  inZoomCard = false,
  ...props
} : StatusBoxProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <StyledStatusBox
      $accent={ props.accent }
      $message={ message }
      $inHeroBanner={ inHeroBanner }
      $inZoomCard={ inZoomCard }
      { ...props }
    >
      <Icon
        aria-hidden="true"
        color={ theme.customColors.textTag }
        icon={ icon }
        size={ isMobile ? "16px" : "24px" }
      />
      {
        (message) ? (
          <Typography
            component="span"
            fontSize={ "0.875rem" }
            fontWeight="500"
            color={ theme.customColors.textTag }
          >
            { message }
          </Typography>
        ): null
      }
    </StyledStatusBox>
  );}
